import * as Sentry from '@sentry/react';
import config from '@/config';

/**
 * Remontée des erreurs du front vers Sentry, seulement si l'environnement fournit un DSN (`sentryDsn` de appConfig.js,
 * ConfigMap teiji-front-app-config) : rien en local ni dans les tests. Erreurs seulement : ni traces de performance, ni
 * replay (il enregistrerait les heures et les noms des employés), ni données personnelles (adresse IP…).
 *
 * @returns vrai si Sentry est actif
 */
export function initSentry(appConfig: AppConfig = config): boolean {
  if (!appConfig.sentryDsn) return false;

  Sentry.init({
    dsn: appConfig.sentryDsn,
    environment: appConfig.sentryEnvironment,
    sendDefaultPii: false,
  });

  return true;
}

/** Signale une erreur attrapée par l'appli (sans effet si Sentry n'est pas actif) */
export function reportError(error: unknown): void {
  Sentry.captureException(error);
}

/** Erreurs de rendu que React n'a pu rattraper (createRoot) */
export const reactErrorHandler = Sentry.reactErrorHandler;
